module.exports = __webpack_public_path__ + "static/burrowshark-fbb459ee1a9a2e2e9a65e12f24c78dcb.jpeg";